/* phq-variant-title stage 2026-09-17 */
(function(){
  function getMap(){
    var el=document.getElementById('mff-variant-titles');
    if(!el) return null;
    try { return JSON.parse(el.textContent); } catch(e){ return null; }
  }
  function selectedId(){
    var input=document.querySelector('form[action*="/cart/add"] input[name="id"], product-form input[name="id"], input[name="id"]');
    if(input && input.value) return String(input.value);
    try {
      var u=new URL(window.location.href);
      var v=u.searchParams.get('variant');
      if(v) return String(v);
    } catch(e){}
    return null;
  }
  function apply(){
    var map=getMap();
    if(!map) return;
    var id=selectedId();
    if(!id || !map[id]) return;
    var el=document.querySelector('h1[data-phq-animal-title]');
    if(!el) return;
    el.textContent=map[id];
  }
  function boot(){
    apply();
    document.addEventListener('change', function(e){
      if(e.target && e.target.matches && e.target.matches('input[type=radio], input[name="id"], select')){
        // Allow Impact to update hidden id first
        setTimeout(apply, 0);
      }
    });
    document.addEventListener('variant:change', function(ev){
      var v=ev.detail && (ev.detail.variant || ev.detail);
      var map=getMap();
      var el=document.querySelector('h1[data-phq-animal-title]');
      if(map && el && v && v.id && map[String(v.id)]){
        el.textContent=map[String(v.id)];
      } else {
        apply();
      }
    });
    document.addEventListener('product:variant-change', apply);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
